<template>
  <div class="benefits">
    <div v-if="hasPoints" class="benefit">
      <PointsStartSvg
        class="benefit__icon"
        size="16px"
        :color="paletteFidmarques.green"
      />
      <br>
      <span :style="{ color: paletteFidmarques.green }">
        {{ pointsCount }}
      </span>
      {{ pointsCount | pluralize("point", "points") }}
    </div>

    <div v-if="hasPuzzlePieces" class="benefit">
      <CollectorPieceSvg
        class="benefit__icon"
        :width="16"
        :color="paletteFidmarques.pink"
      />
      <br>
      <span :style="{ color: paletteFidmarques.pink }">
        {{ collectorPiecesCount }}
      </span>
      {{ collectorPiecesCount | pluralize("pièce", "pièces") }}
    </div>

    <div v-if="hasCoupons" class="benefit benefit--large">
      <VouchersSvg
        class="benefit__icon"
        :width="16"
        :color="paletteFidmarques.blue"
      />
      <br>
      <span :style="{ color: paletteFidmarques.blue } ">
        {{ couponsCount }}
      </span>
      {{ couponsCount | pluralize('bon utilisé', 'bons utilisés') }}
    </div>

    <div v-if="hasCashback" class="benefit benefit--large">
      <EuroSvg
        class="benefit__icon"
        size="16px"
        :color="paletteFidmarques.violet"
      />
      <br>
      <span :style="{ color: paletteFidmarques.violet }">
        {{ potIncrement | money(" €") }}
      </span>

      <span v-if="receiptValidated">
        {{ potIncrement | pluralize("cagnotté", "cagnottés") }}
      </span>
      <span v-else>
        {{ potIncrement | pluralize("remboursé", "remboursés") }}
      </span>
    </div>
  </div>
</template>

<script>
import PointsStartSvg from '../../../assets/images/icons/timeline-message/points-star.svg'
import CollectorPieceSvg from '../../../assets/images/icons/timeline-message/piece.svg'
import VouchersSvg       from '../../../assets/images/icons/timeline-message/vouchers.svg'
import EuroSvg from '../../../assets/images/icons/timeline-message/euro.svg'
import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'
export default {
  components: {
    PointsStartSvg,
    CollectorPieceSvg,
    VouchersSvg,
    EuroSvg,
  },
  mixins: [MixinPaletteFidmarques],
  props: {
    pointsCount: {
      type: Number,
      required: true,
    },
    collectorPiecesCount: {
      type: Number,
      required: true,
    },
    couponsCount: {
      type: Number,
      required: true,
    },
    potIncrement: {
      type: Number,
      required: true,
    },
    receiptValidated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasCashback () {
      return this.potIncrement > 0
    },
    hasPuzzlePieces () {
      return this.collectorPiecesCount > 0
    },
    hasPoints () {
      return this.pointsCount > 0
    },
    hasCoupons () {
      return this.couponsCount > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.benefits {
  margin: 0;
  padding: 0.5rem;
  display: flex;
  // justify-content: space-around;
}
.benefit {
  flex: 1;
  text-align: center;
  white-space: nowrap;
}
.benefit--large {
  flex: 1.75;
}
</style>
